import { Container, Texture } from '../../../odie';

import { ChocolateEggBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const styles = [
  {
    asset: 'chocolateEgg/block.chocolateEgg.0.png',
    y: 38,
  },
  {
    asset: 'chocolateEgg/block.chocolateEgg.1.png',
    y: 38,
  },
  {
    asset: 'chocolateEgg/block.chocolateEgg.2.png',
    y: 38,
  },
  {
    asset: 'chocolateEgg/block.chocolateEgg.3.png',
    y: 38,
  },
];

/*
    chocolate egg block view
*/
export class ChocolateEggBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  private _sprite: FitWidthBlockSprite;
  private _count = 0;

  // properties
  //-------------------------------------------------------------------------
  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    const style = styles[value];

    // update field
    this._count = value;

    // update view texture based on count
    this._sprite.texture = Texture.from(style.asset);

    // position view based on count
    this.y = style.y;
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: ChocolateEggBlockProps) {
    // create base view
    super();
    this._sprite = new FitWidthBlockSprite(styles[0].asset, props);
    this.addChild(this._sprite);
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return styles.map((style) => style.asset);
  }
}
